module.exports = __webpack_public_path__ + "static/img/czekoladaok.5da32e97.webp";